// extracted by mini-css-extract-plugin
export default {"swiper":"swiper-UTnlA","slide":"slide-Kpsd7","freemode":"freemode-Ggwvh","centered":"centered-gg9Cf"};